export default __webpack_public_path__ + "static/media/tw.ac6bcad0.svg";